import { useDispatch } from 'react-redux';
// Components
import { Icon } from '../Icon';
// State functions
import { logoutUser } from '../../clientStore/authSlice/auth-slice';
// Constants
import { IconNames } from '../../util/const';
// Styles
import styles from './LogoutBtn.module.css';

export const LogoutBtn = () => {
  const dispatch = useDispatch();

  const onLogoutClick = () => {
    dispatch(logoutUser());
    window.location.reload();
  };
  return(
    <button
      className={styles.link}
      onClick={onLogoutClick}
    >
     Logout
     <Icon name={ IconNames.LOGOUT }/>
    </button>
  );
};
